import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faClipboardList,
  faCog,
  faFileAlt,
  faStickyNote,
  faEdit,
  faHospitalSymbol,
  faBirthdayCake,
  faPhoneAlt,
  faTicketAlt,
  faSyncAlt,
  faNewspaper,
  faChevronLeft,
  faPercentage,
  faGift,
  faTimesCircle,
  faCheckCircle,
  faCheck,
  faEllipsisV,
  faTrophy,
  faHistory,
  faChevronDown,
  faChevronUp,
  faCalendarAlt,
  faPlus,
  faStar,
  faPencilAlt,
  faArrowAltCircleRight,
  faSignOutAlt,
  faCalendarCheck,
  faGifts,
  faQrcode,
  faInfoCircle,
  faTimes,
  faCamera,
  faHome,
  faCreditCard,
  faFilter,
  faCopy,
  faShare,
  faTrashAlt,
  faBars,
  faList,
  faCrown,
  faMinusCircle,
  faPlusCircle,
  faExpand,
  faSearch,
  faCircle,
  faArrowAltCircleLeft,
  faArrowLeft,
  faRedoAlt,
  faBuilding,
  faCommentDots,
  faBullhorn,
  faReceipt,
  faGlobe,
  faBarcode,
  faIdCard,
  faPassport,
  faUser as solidUser,
  faLocationArrow,
  faQuestion,
  faSlidersH,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import { faUser, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLine } from "@fortawesome/free-brands-svg-icons";

library.add(
  faChevronRight,
  faClipboardList,
  faCog,
  faFileAlt,
  faStickyNote,
  faEdit,
  faChevronLeft,
  faGift,
  faTimesCircle,
  faCheckCircle,
  faCheck,
  faHistory,
  faPlus,
  faStar,
  faHospitalSymbol,
  faBirthdayCake,
  faEnvelope,
  faPhoneAlt,
  faTicketAlt,
  faSyncAlt,
  faNewspaper,
  faPercentage,
  faEllipsisV,
  faPencilAlt,
  faTrophy,
  faChevronDown,
  faChevronUp,
  faCalendarAlt,
  faArrowAltCircleRight,
  faSignOutAlt,
  faCalendarCheck,
  faGifts,
  faQrcode,
  faInfoCircle,
  faTimes,
  faCamera,
  faGift,
  faHome,
  faCreditCard,
  faFilter,
  faLine,
  faCopy,
  faShare,
  faTrashAlt,
  faBars,
  faList,
  faCrown,
  faMinusCircle,
  faPlusCircle,
  faExpand,
  faUser,
  faSearch,
  faCircle,
  faArrowAltCircleLeft,
  faArrowLeft,
  faRedoAlt,
  faBuilding,
  faCommentDots,
  faBullhorn,
  faReceipt,
  faGlobe,
  faBarcode,
  faIdCard,
  faPassport,
  faBarcode,
  solidUser,
  faSlidersH,
  faMinus,
  faLocationArrow,
  faQuestion
);
